export default __webpack_public_path__ + "static/measure-group-2ffd6fda15e2b6a9a2aacdc9a1c8f2da.png";